(() => {
  'use strict';

  function connectPreferences() {
    const banner = typeof privacyBanner === 'undefined' ? null : privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;

    document.querySelectorAll('[data-bringners-cookie-preferences]').forEach((button) => {
      if (button.dataset.privacyConnected) return;
      button.dataset.privacyConnected = 'true';
      button.hidden = false;
      button.addEventListener('click', async () => {
        const error = button.parentElement.querySelector('[data-bringners-cookie-error]');
        error.hidden = true;
        button.disabled = true;
        try {
          await banner.showPreferences();
        } catch (_) {
          error.hidden = false;
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectPreferences, { once: true });
  } else {
    connectPreferences();
  }
  if (document.readyState !== 'complete') {
    window.addEventListener('load', connectPreferences, { once: true });
  }
  document.addEventListener('shopify:section:load', connectPreferences);
})();
